import React, { ComponentPropsWithoutRef } from 'react';
import { Modal } from 'antd';
import { StoreDetails } from '../../../../../types/store';
import useHelpers from '../../../../../hooks/utility/useHelpers';
import { EnvironmentOutlined } from '@ant-design/icons';

type Props = ComponentPropsWithoutRef<typeof Modal> & { data: StoreDetails };

const DeliveryRadiusModal = ({ data, ...rest }: Props) => {
  const deliveryZones = data?.order_settings?.delivery_zones?.filter(
    (zone) => 'radius' in zone.geometry_data,
  );
  const { formatCurrency } = useHelpers();
  const getKmLabelFromRadius = (radius: number) => `${~~(radius / 1000)}km`;

  return (
    <Modal
      title="Delivery radius"
      footer={null}
      {...rest}
      classNames={{
        header: '[&_*]:!text-[18px] [&_*]:!text-slate-700 !bg-slate-100',
        body: 'space-y-3',
        content: '!bg-slate-100',
      }}
    >
      <section className="border rounded p-3 rounded-lg space-y-2 bg-slate-700/5">
        <h5 className="text-md text-slate-600">
          <EnvironmentOutlined className="mr-2 text-md" />
          {data.name}
        </h5>
        <p className="text-slate-600 text-sm">{data.location.formatted_address}</p>
      </section>
      <h5 className="text-sm font-semibold text-slate-700">Delivery zones:</h5>
      {deliveryZones?.map((zone) => (
        <article key={zone.id} className="space-y-2 p-3 rounded-lg border bg-white">
          <div className="flex justify-between">
            <p className="text-sm font-medium">{zone.name}</p>
            <p className="rounded-full border px-2 py-1 text-xs font-medium">
              {getKmLabelFromRadius((zone.geometry_data as any).radius)}
            </p>
          </div>
          <p className="text-xs text-slate-600">{formatCurrency(zone.fee)}</p>
        </article>
      ))}
    </Modal>
  );
};

export default DeliveryRadiusModal;
